import { createFileRoute, useParams } from "@tanstack/react-router";

import { PackagePatternConfigDetail } from "@/features/operation-package-config-new/PackagePatternDetail";
import { defaultNS, useTranslation } from "@/lib/i18n";

export const Route = createFileRoute(
  "/_staff/ga-operation-core/config/$patternId/",
)({
  component: PatternDetailPage,
});

function PatternDetailPage() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.gaOperationCore.operationPackages",
  });
  const { patternId } = useParams({
    from: "/_staff/ga-operation-core/config/$patternId/",
  });

  return (
    <PackagePatternConfigDetail
      ownerProduct="GA_OPERATION_CORE"
      breadcrumbs={[
        {
          linkTo: "/ga-operation-core/configs",
          label: t("gaOperationCore"),
        },
      ]}
      patternId={patternId}
    />
  );
}
